/** Access-denied and incompatible-profile states share the content layout and home action.
 * Route guards decide access; this component only presents the resolved state. */
import { Link } from 'react-router-dom';

const COPY = {
  denied: {
    icon: 'lock_person',
    title: 'No tienes acceso a este modulo',
    text: (moduleTitle) => (
      <>Tu perfil no incluye permiso para entrar a <strong>{moduleTitle}</strong>. Si necesitas acceso, solicitalo a un administrador.</>
    ),
  },
  incompatible: {
    icon: 'block',
    title: 'Este modulo no es compatible con tu perfil',
    text: () => 'El Reporte de Drivers es una herramienta de uso interno de Walmart. Si necesitas reportar una incidencia, contacta a tu Subgerente Last Mile.',
  },
};

export default function DeniedScreen({ variant = 'denied', moduleTitle = 'este modulo' }) {
  const copy = COPY[variant];
  return (
    <div className="app-card">
      <div className="denied-wrap">
        <span className="denied-icon">
          <span className="material-symbols-rounded" aria-hidden="true">{copy.icon}</span>
        </span>
        <h2 className="denied-title">{copy.title}</h2>
        <p className="denied-text">{copy.text(moduleTitle)}</p>
        <div className="denied-actions">
          <Link className="btn btn-secondary" to="/">
            <span className="material-symbols-rounded icon-sm" aria-hidden="true">home</span>
            Ir a Inicio
          </Link>
        </div>
      </div>
    </div>
  );
}
